import { ToastContainer as ReactToastContainer, ToastContainerProps } from 'react-toastify';

import { hookUtils } from '@pukka/common/utils';

import 'react-toastify/dist/ReactToastify.min.css';
import './toast.css';

function ToastContainer({ autoClose = 5000, limit = 1, closeOnClick = true, style, ...props }: ToastContainerProps) {
  const mainRect = hookUtils.useMainLayout();
  const padding = hookUtils.useIsMobile() ? 0 : 60;

  return (
    <ReactToastContainer
      position="bottom-right"
      icon={false}
      closeButton={false}
      autoClose={autoClose}
      limit={limit}
      closeOnClick={closeOnClick}
      style={{
        ['--toastify-toast-width' as string]: `${(mainRect.width - padding) / 2}px`,
        ...style,
      }}
      {...props}
    />
  );
}

export { ToastContainer };
